// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30VJM","title":"styles_title__pWOzK"};